import React from 'react';
import { Heading, Link, MenuText } from '@placer-ui/components';
import { goToSignIn } from 'router/go-to';
import { VerifyEmailIllustration } from 'features/authentication/signup/components/verify-email-illustration/verify-email-illustration';
import { shouldRenderMobileApp } from 'utils/detect-environment';
import styles from './email-sent-page.module.scss';

export const EmailSentPage = () => {
    const isMobile = shouldRenderMobileApp();

    return (
        <div className={styles.emailSentPage}>
            <VerifyEmailIllustration isMobile={isMobile} />
            <div className={styles.body}>
                <Heading variant="h2" testId="email-sent-page-login-header">
                    Email Sent
                </Heading>
                <MenuText color="primary">
                    Please check your inbox for password recovery instructions.
                </MenuText>
            </div>
            <div className={styles.backToLoginContainer}>
                <span>Take me back to</span>
                <Link
                    onClick={() => goToSignIn()}
                    size="medium"
                    weight="semi-bold"
                    hideUnderline={false}
                >
                    Login
                </Link>
            </div>
        </div>
    );
};
